<button [ngClass]="mode">
    <ng-content></ng-content>
</button>